import { NgModule } from '@angular/core';

import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';

// Modules Material utilises

// Autres modules externes utilises 

// Modules communs utilises

// Composants metiers
import { CheckboxListComponent } from './components/checkbox-list.component';
import { EntityCheckboxListComponent } from './components/entity-checkbox-list.component';

// Services metier

@NgModule({
	imports: [
		BrowserModule,
		FormsModule,
	],
	providers: [
	],
	declarations: [
		CheckboxListComponent,
		EntityCheckboxListComponent,
	],
	exports: [
		CheckboxListComponent,
		EntityCheckboxListComponent,
	]
})
export class CheckboxListModule {
	constructor() { }
}